
const LabelSelect = ({text,name,options, handleChange,placeholder = true, value}) => {

    return (
        <label className="input-text__wrapper input-text__label-top">
              {text}
              <select onChange={(e) => handleChange(e)}    
                  className="login-form__input input-text"
                  text={text}
                 
                  name={name}
                  value={value !== undefined ? value : undefined}
                  defaultValue={value === undefined ? "" : undefined}
              >
                {
                    placeholder ?
                    <option value={''} > </option>
                    : null
                }
                 
              {
                options.map(item => 
                  <option key={`${name}-${item.value}`} value={item.value}>{item.txt}</option>)
               }               
            </select>
        </label>
    )
}

export default LabelSelect;
